export enum CompanySetupQueryKeysEnum {
  COMPANY_SETUP_LIST_STATE = 'companySetupListState',
}
